import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { getInitialOnlineStatus, registerOnlineListeners } from '../utils/pwaUtils';

const OfflineBanner: React.FC = () => {
  const [isOnline, setIsOnline] = useState(getInitialOnlineStatus);

  useEffect(() => registerOnlineListeners(setIsOnline), []);

  if (isOnline) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-2 bg-amber-600 px-4 py-2 text-sm font-medium text-white shadow-lg"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>Modo sin conexión — la app sigue disponible con datos locales</span>
    </div>
  );
};

export default OfflineBanner;
